define.alias("ember-cli-clipboard/components/copy-button", "media/components/copy-button");